import type { SearchQueryParams } from 'afpnews-api'
import type { Column, Locale } from '@/types'

export interface OnboardingDefault {
  id: 'all-news' | 'topshot'
  labelKey: string
  descriptionKey: string
  icon: string
  type: Column['type']
  buildParams: (lang: Locale) => Partial<SearchQueryParams>
}

export const ONBOARDING_DEFAULTS: OnboardingDefault[] = [
  {
    id: 'all-news',
    labelKey: 'onboarding.templates.defaults.all-news.label',
    descriptionKey: 'onboarding.templates.defaults.all-news.description',
    icon: 'mdi--newspaper-variant',
    type: 'search',
    buildParams: lang => ({
      langs: [lang]
    })
  },
  {
    id: 'topshot',
    labelKey: 'onboarding.templates.defaults.topshot.label',
    descriptionKey: 'onboarding.templates.defaults.topshot.description',
    icon: 'mdi--camera-iris',
    type: 'search',
    buildParams: () => ({
      langs: [],
      class: 'picture',
      query: 'topshot'
    })
  }
]
